import {
  CLOSE_ACTION_CARD,
  OPEN_ACTION_CARD,
  UPDATE_ACTION_CARDS,
  UPDATE_ERROR_MESSAGE_ID,
} from './actions';
import { initialStore, PKG_NAME, ScopedStore } from './store';

const scopedRootReducer = (state: ScopedStore = initialStore, action) => {
  switch (action.type) {
    case UPDATE_ERROR_MESSAGE_ID:
      return {
        ...state,
        errorMsgId: state.errorMsgId || action.payload,
      };
    case OPEN_ACTION_CARD:
      return {
        ...state,
        actionCardType: action.payload,
      };
    case CLOSE_ACTION_CARD:
      return {
        ...state,
        actionCardType: undefined,
      };
    case UPDATE_ACTION_CARDS:
      return {
        ...state,
        actionCards: {
          ...state.actionCards,
          ...action.payload,
        },
      };
    default:
      return { ...state };
  }
};

const scopedReducers = {
  [PKG_NAME]: scopedRootReducer,
};

export default scopedReducers;
